<template>
  <div class="home">
    <!-- Header -->
    <PhoneHeader @openForm="handleMenu"></PhoneHeader>
    <div class="banner-box">
      <div class="banner-con">
        <div class="banner-title">轻骑兵低代码开发平台</div>
        <div class="banner-desc">让软件开发更简单</div>
        <!-- 顶部视频 -->
        <div class="banner-video-bg">
          <div class="banner-videoBox">
            <div class="banner-video" @click="startBannerVideo('default')">
              <img
                src="../assets/img/homePage/banner-start1.png"
                alt="播放"
                style="height: 35px"
              />
            </div>
          </div>
        </div>
        <!-- 产品视频 -->
        <div class="productVideo-box">
          <div class="video-title">产品视频</div>
          <div class="video-list">
            <div class="video-item" v-for="item in videoList" :key="item.id">
              <div
                class="item-box"
                :style="getBackgroundStyle(item.id)"
                @click="startBannerVideo(item)"
              >
                <img
                  src="../assets/img/homePage/banner-start1.png"
                  alt="播放"
                  style="height: 35px"
                />
              </div>
              <div class="item-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <!-- 产品文档 -->
        <div class="productDoc-box">
          <div class="productDoc-title">产品文档</div>
          <div class="productDoc-list">
            <div
              class="doc-item"
              v-for="item in productFileList"
              :key="item.id"
            >
              <div class="fileItem" @click="openFileForm">
                <div v-if="item.type === 'pdf'" class="fileItem_pdf">
                  <div class="line"></div>
                  <div class="fileInfo fileName">{{ item.name }}</div>
                  <div class="fileInfo fileTitle">{{ item.title }}</div>
                </div>
                <div v-if="item.type === 'word'" class="fileItem_word">
                  <div class="line"></div>
                  <div class="fileInfo fileName">{{ item.name }}</div>
                  <div class="fileInfo fileTitle">{{ item.title }}</div>
                </div>
                <div v-if="item.type === 'ppt'" class="fileItem_ppt">
                  <div class="line"></div>
                  <div class="fileInfo fileName">{{ item.name }}</div>
                  <div class="fileInfo fileTitle">{{ item.title }}</div>
                </div>
                <div class="download">
                  <img
                    src="@/assets/img/documentPhonePage/download.png"
                    @click="openFileForm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部公司信息 -->
      <CompanyInformation
        @changePracticeMenuShow="handleOpenPractice"
      ></CompanyInformation>
      <!-- 右侧菜单 -->
      <RightMenu
        :isMenuShow="isMenuShow"
        @rightMenuShow="handleRightMenuShow"
      ></RightMenu>
      <!-- 底部立即体验弹出 -->
      <ExperienceNow
        :isPopShow="isPopShow"
        @CloseExperienceNow="handleCloseExperienceNow"
      ></ExperienceNow>
      <!-- 视频弹窗 -->
      <el-dialog
        v-show="videoPlayDialogVisible"
        :visible.sync="videoPlayDialogVisible"
        width="98%"
        class="video-dialog"
        @close="closeVideoPlayDialog"
      >
        <video
          style="width: 100%"
          :src="videoSrc"
          ref="video"
          controls
          playsinline
          webkit-playsinline
          autoplay
        ></video>
      </el-dialog>
    </div>
    <PhoneFooter @handleFooter="handleOpenPractice"></PhoneFooter>
  </div>
</template>

<script>
import PhoneHeader from "./include/PhoneHeader";
import PhoneFooter from "./include/PhoneFooter";
import RightMenu from "./include/RightMenu";
import CompanyInformation from "./include/CompanyInformation";
import ExperienceNow from "./include/ExperienceNow";

export default {
  name: "HussarHomePhonePage",
  components: {
    PhoneFooter,
    PhoneHeader,
    CompanyInformation,
    RightMenu,
    ExperienceNow,
  },
  data() {
    return {
      isPopShow: false, // 立即体验弹窗
      isMenuShow: false, // 顶部菜单栏
      videoPlayDialogVisible: false, // 视频播放弹窗
      videoDefault: window.location.protocol+ '//'+window.location.hostname+"/video/qqbxc.mp4", // 默认视频路径
      videoSrc: "", // 视频路径
      // 视频列表
      videoList: [
        {
          id: "1",
          path: window.location.protocol+ '//'+window.location.hostname+'/video/Hussar_development.mp4',
          name: "轻骑兵二次开发-前端代码块",
        },
        {
          id: "2",
          path: window.location.protocol+ '//'+window.location.hostname+'/video/Hussar_theme.mp4',
          name: "轻骑兵主题配置",
        },
        {id:'3',path: window.location.protocol+ '//'+window.location.hostname+'/video/hussar_ai.mp4',name: '轻骑兵AI低代码开发平台'},
        {id:'4',path: window.location.protocol+ '//'+window.location.hostname+'/video/Hussar_score.mp4',name: '轻骑兵低代码开发平台成绩单'},
      ],
      // 产品文档列表
      productFileList: [
        {id:'1',type: 'pdf',path: '',name: 'AI时代下中国低/零代码市场发展研究', title: ''},
        {id:'5',type: 'pdf',path: '',name: 'IDC企业级低代码开发体系建设指南', title: ''},
        {id:'4',type: 'pdf',path: '',name: 'IDC生成式AI+低代码 探索新一代开发范式', title: ''},
        {id:'2',type: 'pdf',path: '',name: '系统与软件工程 低代码开发平台通用技术要求', title: ''},
        {id:'3',type: 'pdf',path: '',name: '企业级智能体技术与应用研究报告', title: ''},
        {id:'6',type: 'word',path: '',name: '轻骑兵低代码开发平台白皮书', title: ''},
      ],
    };
  },
  watch: {},
  methods: {
    // 打开视频并播放
    startBannerVideo(item) {
      const self = this;
      if (item === "default") {
        self.videoSrc = self.videoDefault;
        self.videoPlayDialogVisible = true;
        return;
      }
      self.videoSrc = item.path;
      self.videoPlayDialogVisible = true;
      self.$nextTick(() => {
        self.$refs.video.play();
      });
    },
    // 关闭视频弹窗暂停视频播放
    closeVideoPlayDialog() {
      const self = this;
      self.$refs.video.pause();
    },
    // 打开右侧菜单弹窗
    handleMenu() {
      const self = this;
      self.isMenuShow = true;
    },
    // 关闭右侧菜单弹窗
    handleRightMenuShow() {
      const self = this;
      self.isMenuShow = false;
    },
    // 打开立即体验弹窗
    handleOpenPractice() {
      const self = this;
      self.isPopShow = true;
    },
    // 关闭立即体验弹窗
    handleCloseExperienceNow() {
      const self = this;
      self.isPopShow = false;
    },
    // 下载文档
    openFileForm() {
      this.handleOpenPractice();
    },
    // 修改背景图片
    getBackgroundStyle(id) {
      let img = "";
      switch (id) {
        case "1":
          img = require("@/assets/img/documentPhonePage/video1.png");
          break;
        case "2":
          img = require("@/assets/img/documentPhonePage/video2.png");
          break;
        case "3":
          img = require("@/assets/img/documentPhonePage/video-ai.png");
          break;
        case "4":
          img = require("@/assets/img/documentPhonePage/video3.png");
          break;
        // 其他情况
      }
      return {
        background: "url(" + img + ") no-repeat",
        backgroundSize: "100%",
      };
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* 视频区域 */
.banner-box {
  width: 100%;
  height: 391px;
  background: url("../assets/img/phoneHomePage/banner-bg.png");
  background-size: cover;
}

.banner-con {
  width: 100%;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 30px;
}

.banner-title {
  font-size: 29px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}

.banner-desc {
  display: flex;
  align-items: center;
  position: relative;
  height: 40px;
  font-size: 18px;
  font-weight: 400;
  justify-content: center;
}

.banner-video-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  padding-bottom: 30px;
}

.banner-videoBox {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  width: 310px;
  height: 180px;
}

.banner-video {
  justify-content: center;
  background: url("../assets/img/phoneHomePage/video-bg2.png") no-repeat;
  background-size: 100%;
  transform: 100%;
  text-align: center;
  width: 300px;
  height: 170px;
  background-color: #ccc;
}

.banner-video > img {
  margin-top: 65px;
}
/* 视频区域end */
/* 主页视频弹窗 */
.video-dialog {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.video-dialog /deep/ .el-dialog__header {
  padding: 0;
}
.video-dialog /deep/ .el-dialog__body {
  padding: 0;
  height: 210px;
}
.video-dialog /deep/ .el-dialog__headerbtn {
  font-size: 24px;
  z-index: 1;
}
.video-dialog /deep/ .el-dialog {
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/* 主页视频弹窗end */
/* 产品视频 */
.productVideo-box {
  margin: 50px 35px 20px 35px;
}
.video-title {
  font-size: 27px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}
.video-item {
  background: #ffffff;
  width: 100%;
  box-shadow: 0px 0px 15px 1px rgba(3, 64, 170, 0.2);
  margin-top: 35px;
}

.item-box {
  width: 100%;
  height: 180px;
  justify-content: center;
  background: url("../assets/img/phoneHomePage/video-bg2.png") no-repeat;
  background-size: 100%;
  transform: 100%;
  text-align: center;
  background-color: #fff;
}

.item-box > img {
  margin-top: 75px;
}
.item-title {
  padding: 20px;
  font-size: 15px;
  font-weight: 600;
}
/* 产品视频end */
/* 产品文档 */
.productDoc-box {
  margin: 50px 35px 20px 35px;
}
.productDoc-title {
  font-size: 27px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
}
.doc-item {
  background: #ffffff;
  width: 100%;
  box-shadow: 0px 0px 15px 1px rgba(65, 84, 84, 0.138);
  margin-top: 35px;
}
.fileItem_pdf {
  background: url("~@/assets/img/documentPage/pdf-bg.png") no-repeat;
  background-size: cover;
  width: 100%;
  height: 132px;
}
.fileItem_word {
  background: url("~@/assets/img/documentPage/word-bg.png") no-repeat;
  background-size: cover;
  width: 100%;
  height: 132px;
}
.fileItem_ppt {
  background: url("~@/assets/img/documentPage/ppt-bg.png") no-repeat;
  background-size: cover;
  width: 100%;
  height: 132px;
}
.line {
  width: 36px;
  height: 3px;
  border-radius: 20px;
  margin-top: 39px;
  margin-left: 26px;
  position: absolute;
}
.fileItem_pdf .line {
  background: #ff6b6b;
}
.fileItem_word .line {
  background: #2a8ff5;
}
.fileItem_ppt .line {
  background: #f88448;
}
.fileInfo {
  font-size: 14px;
  font-weight: bold;
  color: #2e2e2e;
  line-height: 32px;
  text-align: left;
  position: absolute;
  max-width: 160px;
  margin-left: 26px;
}
.fileName {
  margin-top: 50px;
}
.fileTitle {
  margin-top: 76px;
}
.fileItem img {
  height: 22px;
  /* margin-bottom: 10px; */
  cursor: pointer;
}
.fileItem .download {
  display: flex;
  align-items: center;
  padding: 10px;
  justify-content: center;
}
/* 产品文档end */
</style>



// WEBPACK FOOTER //
// src/components/DocumentPhonePage.vue